import * as React from 'react';
import { Button, Icon } from '@symphony-ui/uitoolkit-components';
import IFRStoryV3Modal from './IFRStoryV3Modal';
const IFRStreamItemV3 = ({ story }) => {
    const [showModal, setShowModal] = React.useState(false);
    const onClick = React.useCallback(() => {
        setShowModal(true);
    }, []);
    return (React.createElement("div", { style: {
            display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem', width: '100%',
        } },
        showModal ?
            React.createElement(IFRStoryV3Modal, { onClose: () => setShowModal(false), story: story })
            : undefined,
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement("div", { style: { marginRight: '1rem' } },
                React.createElement(Button, { onClick: onClick, size: "small" },
                    React.createElement(Icon, { iconName: "plus" }))),
            React.createElement("p", null,
                story.date.toLocaleString(),
                ' ',
                "-",
                ' ',
                story.headline)),
        React.createElement("div", { style: { display: 'flex' } },
            React.createElement("div", null,
                React.createElement("p", { style: { fontSize: 'small' } }, story.assetTags.join(", "))))));
};
export default IFRStreamItemV3;
